import React from "react";

function Home() {
  return <div style={{display:'flex',alignContent:'center', margin:'100px'}}>
    <img style={{borderRadius:'20px'}} src="https://res.cloudinary.com/dbrqv6ypj/image/upload/v1668764501/Sibarita-img/lkxiolll3t50umx0sgsq.jpg" alt="logo-img" />
  </div>;
}

export default Home;
